import React from "react";
import { useNavigate } from "react-router-dom";
import Span from "../../helper/Span";
import style from "../../sass/navigation.module.scss";
import Hamburger from "./Hamburger";
import NavList from "./NavList";

const Navigation = () => {
     const navigate = useNavigate();
     const handleNavigation = () => {
          navigate("/");
     };
     return (
          <nav className={style.navigation}>
               <div className={style["navigation-logo"]} onClick={handleNavigation}>
                    {"<Richhapal-Choudhary/>".split("").map((alphabet, index) => (
                         <Span alp={alphabet} key={index} />
                    ))}
               </div>
               <ul className={style["navigation-items"]} id={style.navNone}>
                    <NavList />
               </ul>
               <Hamburger />
          </nav>
     );
};
export default Navigation;
